import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/lib/pwa";

// Thin sticky bar shown while offline (kept tiny so it can ship in the first bundle).
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnlineStatus();
  const location = useLocation();
  if (online || location.pathname.startsWith("/workspace")) return null;
  return (
    <div data-testid="offline-banner" role="status" className="sticky top-0 z-[60] flex items-center justify-center gap-2 bg-amber-500 text-[#0B132B] text-xs font-semibold px-3 min-h-[36px]">
      <WifiOff size={14} /> {t("pwa.offline")} <Link to="/guides" className="underline underline-offset-2 ml-1 min-h-[36px] inline-flex items-center" data-testid="offline-guides-link">{t("pwa.offlineGuides")}</Link>
    </div>
  );
}
